import {
    GETWALLETDASHBOARD_SUCCESS,
    GETWALLETDASHBOARD_FAILED,
    RESET_GETWALLETDASHBOARD,
    LOADING_GETWALLETDASHBOARD,
    NETWORK_ERROR_GETWALLETDASHBOARD,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWALLETDASHBOARD:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWALLETDASHBOARD_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWALLETDASHBOARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWALLETDASHBOARD:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWALLETDASHBOARD:
            return (state = initialState);
        default:
            return state;
    }
};
